// extracted by mini-css-extract-plugin
export default {"Thanks":"Thanks_Thanks__ebkbZ","testers":"Thanks_testers__y36DG","wrapper":"Thanks_wrapper__lIZHr"};